import { AppContext } from "@/App";
import { useContext, useState } from "react";
import { Tutorial, hasCompletedTutorial, markTutorialCompleted, getTutorialName } from "@/lib/utils";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { getTutorialMessage } from "./TutorialMessages";

interface TutorialCheckerProps {
    tutorialId: Tutorial;
    tutorial: () => void;
}

const TutorialChecker = ({ tutorialId, tutorial }: TutorialCheckerProps) => {
    const app = useContext(AppContext);
    const [dialogOpen, setDialogOpen] = useState(true);
    //const [dialogTitle, setDialogTitle] = useState("");
    //const [dialogContent, setDialogContent] = useState<React.ReactNode>(buildDialogContent());

    // Get tutorialsCompleted directly from context to ensure it's always current
    const getTutorialsCompleted = () => {
        const value = app?.applicationUser?.userSettings?.tutorialsCompleted || 0;
        return value;
    };

    function buildDialogTitle() {
        const name = getTutorialName(tutorialId);
        const title = `Start ${name} Guided Tour?`;
        return title;
    }

    function buildDialogContent() {
        const message = getTutorialMessage(tutorialId);

        return (<div className="flex flex-col gap-4">
            <p>{message}</p>
            <p>You can access this tour anytime from the Help menu.</p>
            <div className="flex flex-row items-center gap-2">
                
            </div>
            <div className="flex flex-row items-center gap-2">
                <input type="checkbox" id="dont-show-again" />
                <label htmlFor="dont-show-again">Don't show this again</label>
                <button
                    className="px-4 ml-auto py-2 bg-blue-600 text-white rounded hover:bg-blue-700 self-end"
                    onClick={() => {
                        setDialogOpen(false);
                        tutorial();
                        const tutorialsCompleted = getTutorialsCompleted();
                        const updatedTutorialsCompleted = markTutorialCompleted(tutorialsCompleted, tutorialId);
                        app?.updateUserSettings("tutorialsCompleted", updatedTutorialsCompleted.toString());
                    }}
                >
                    Start Tutorial
                </button>
                <button
                    className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 self-end"
                    onClick={() => {
                        setDialogOpen(false);
                        if ((document.getElementById("dont-show-again") as HTMLInputElement).checked) {
                            const tutorialsCompleted = getTutorialsCompleted();
                            const updatedTutorialsCompleted = markTutorialCompleted(tutorialsCompleted, tutorialId);
                            app?.updateUserSettings("tutorialsCompleted", updatedTutorialsCompleted.toString());
                        }
                    }}
                >
                    Cancel
                </button>
            </div>
        </div>
        );
    }

    if (hasCompletedTutorial(getTutorialsCompleted(), tutorialId)) {
        return null; // User has completed this tutorial, don't show anything
    }

    return (
        <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
            <DialogContent id="tutorial-checker-dialog" className="flex flex-col max-w-fit">
                <DialogHeader>
                    <DialogTitle>{buildDialogTitle()}</DialogTitle>
                </DialogHeader>
                {buildDialogContent()}
            </DialogContent>
        </Dialog>
    )
}

export default TutorialChecker